/*
 * Title: 회원초대 서비스
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 * @Object: GentleServiceInviteMember
 * @Property Value
 * - sponserId: 후원인 아이디 
 * - sponserName: 후원인 이름 
 * @Property Method
 * - selectInviteType: 회원초대방식선택
 * - sponserIsMe: 나를 후원인으로 초대장 생성
 * - sponserIsOther: 다른 사람을 후원인으로 초대장 생성 
 */

import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleApi from '../common/api';
import GentleLang from '../common/lang';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import ChatSession from '../../../src/main/resources/static/assets/js/webchat/webChatClient_session';

var GentleServiceFallback = Object.create(GentleWidget, {
    sponserId: {
        writable: true,
        configurable: false,
        enumerable: true
    },
    sponserName: {
        writable: true,
        configurable: false,
        enumerable: true
    }
})

GentleServiceFallback.fallbackThird = function () {
    const component = Object.create(this);

    const render = function () {
        {
            const text = GentleLang.translate(GentleLang.type.FallbackThird);
            const option = [{
                text: text,
                user: 'user',
                onClick: function () {
                    popularQestion();
                },
            }, ]
            var button = Object.create(GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
        {
            const text = GentleLang.translate(GentleLang.type.FallbackThird);
            const option = [{
                text: text,
                user: 'user',
                onClick: function () {
                    goKakaoLink();
                },
            }, ]
            var button = Object.create(GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
        //자주묻는질문 버튼
        const popularQestion = function () {
           console.log('자주하는 질문 버튼 클릭!')
           window.chatSession.chatText('FAQ')

        }
        const goKakaoLink = function () {
            console.log('카카오 채팅 시작!')
            (GentleAppState.isPc) ? window.open(language.url.pc.KakaoChatLink) : window.open(language.url.mobile.KakaoChatLink);

        }
    }


    render();
}







export default GentleServiceFallback;